'use client';
import { useRef, useCallback } from 'react';
import { useCallbackRef } from '../use-callback-ref/use-callback-ref.mjs';

function useThrottledCallback(callback, wait) {
  const handleCallback = useCallbackRef(callback);
  const active = useRef(true);
  const timeout = useRef(-1);
  const throttled = useCallback(
    (...args) => {
      if (active.current) {
        active.current = false;
        handleCallback(...args);
        timeout.current = window.setTimeout(() => {
          active.current = true;
        }, wait);
      }
    },
    [wait]
  );
  return throttled;
}

export { useThrottledCallback };
//# sourceMappingURL=use-throttled-callback.mjs.map
